import { DndContext } from '@dnd-kit/core';
import styles from './Main.desktop.module.css';
import { useMainController } from '../Main.controller';
import MenuView from '../../../components/menu/Menu.view';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import ControlsView from '../../../components/zoom/Controls.view';
import CanvasView from '../../../components/canvas/Canvas.view';
import MarketComponentDetailsDialogView from '../../../dialogs/market-component-details-dialog/MarketComponentDetailsDialog.view';
import { getDesktopMenuWidth } from '../../../tools/ConfigurationReader';
import EditMarketView from '../../../components/edit-market/EditMarket.view';
import canEditMarketComponent from '../../../security/CanEditMarketComponent';
import MarketComponentEditDialogView from '../../../dialogs/market-component-edit-dialog/MarketComponentEditDialog.view';
import TechnicalView from '../../../components/technical/Technical.view';
import React, { type CSSProperties } from 'react';
import BackgroundView from '../../../components/background/Background.view.tsx';
import LoaderView from '../../../components/loader/Loader.view.tsx';
import MenuEnum from '../../../components/menu/Menu.enum.ts';

export default function MainDesktopView() {
  const {
    marketComponents,
    isDetailsDialogOpen,
    isEditDialogOpen,
    currentMarketComponent,
    enableZoom,
    loading,
    handleDragEnd,
    removeMarketComponent,
    handleDialogOpenDetails,
    handleDialogOpenEdit,
    handleDialogClose,
  } = useMainController();

  return (
    <div className={styles.main}>
      {isDetailsDialogOpen && (
        <MarketComponentDetailsDialogView
          marketComponent={currentMarketComponent}
          handleDialogCloseClick={handleDialogClose}
        />
      )}

      {canEditMarketComponent() && isEditDialogOpen && (
        <MarketComponentEditDialogView
          marketComponent={currentMarketComponent}
          handleDialogCloseClick={handleDialogClose}
          removeMarketComponent={removeMarketComponent}
        />
      )}

      {loading && <LoaderView />}
      {!loading && (
        <>
          <MenuView menu={MenuEnum.MarketManagement} />
          <EditMarketView />
          <TransformWrapper
            initialScale={0.2}
            minScale={0.1}
            limitToBounds={false}
            disabled={!enableZoom}
          >
            <ControlsView />
            <TechnicalView />
            <TransformComponent
              wrapperClass={styles.zoomContainer}
              wrapperStyle={
                {
                  '--menuWidth': getDesktopMenuWidth(),
                } as CSSProperties
              }
            >
              <BackgroundView />
              <DndContext onDragEnd={handleDragEnd}>
                <CanvasView
                  blockX={3}
                  blockY={3}
                  marketComponents={marketComponents}
                  handleDialogOpenDetails={handleDialogOpenDetails}
                  handleDialogOpenEdit={handleDialogOpenEdit}
                />
              </DndContext>
            </TransformComponent>
          </TransformWrapper>
        </>
      )}
    </div>
  );
}
